import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Package, Plus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useServiceOrders } from "@/providers/ServiceOrdersProvider";
import { GitHubConnectDialog } from "@/components/portal/GitHubConnectDialog";
import { ServiceOrderCard } from "./ServiceOrderCard";

export function ServiceOrdersPage() {
  const navigate = useNavigate();
  const { serviceOrders } = useServiceOrders();
  const [repoDialogOpen, setRepoDialogOpen] = useState(false);
  const [selectedServiceOrderId, setSelectedServiceOrderId] = useState<
    string | undefined
  >();

  const handleConnectRepo = (serviceOrderId?: string) => {
    setSelectedServiceOrderId(serviceOrderId);
    setRepoDialogOpen(true);
  };

  return (
    <div>

      <div className="flex items-start justify-between gap-4 mb-8">
        <div>
          <h1 className="font-display text-3xl font-bold mb-2">
            Service Orders
          </h1>
          <p className="text-muted-foreground">
            View and manage your active service orders and project deliverables.
          </p>
        </div>
        <Button
          onClick={() => navigate("/create-solution")}
          className="shrink-0"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create new service order
        </Button>
      </div>

      {serviceOrders.length === 0 ? (
        <Card className="border-dashed">
          <CardContent className="flex flex-col items-center justify-center py-16">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
              <Package className="h-8 w-8 text-primary" />
            </div>
            <h3 className="font-semibold text-lg mb-2">
              No service orders yet
            </h3>
            <p className="text-muted-foreground text-center max-w-md mb-6">
              Get started by creating your first solution. Choose from our
              service packages or build a custom solution.
            </p>
            <Button onClick={() => navigate("/create-solution")}>
              <Plus className="h-4 w-4 mr-2" />
              Create Solution
            </Button>
          </CardContent>
        </Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {serviceOrders.map((so) => (
            <ServiceOrderCard
              key={so.id}
              serviceOrder={so}
              onConnectRepo={handleConnectRepo}
            />
          ))}
        </div>
      )}

      <GitHubConnectDialog
        open={repoDialogOpen}
        onOpenChange={setRepoDialogOpen}
        serviceOrderId={selectedServiceOrderId}
      />
    </div>
  );
}
